import { render, staticRenderFns } from "./TotalClosingOrder.vue?vue&type=template&id=22af5b6c&scoped=true&"
import script from "./TotalClosingOrder.vue?vue&type=script&lang=js&"
export * from "./TotalClosingOrder.vue?vue&type=script&lang=js&"
import style0 from "./TotalClosingOrder.vue?vue&type=style&index=0&id=22af5b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af5b6c",
  null
  
)

export default component.exports